import React from 'react';
import { Link } from 'react-router-dom';

const GuideCTA = ({
    title,
    description,
    ctaText,
    ctaLink = '/',
    secondaryText = 'Voir les tarifs',
    secondaryLink = '/pricing',
}) => {
    return (
        <div className="cta-band text-center">
            <h3 className="text-xl font-semibold mb-2">{title}</h3>
            <p className="text-slate-300 text-sm mb-5 max-w-2xl mx-auto">{description}</p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <Link to={ctaLink} className="btn-primary">
                    {ctaText}
                </Link>
                <Link to={secondaryLink} className="btn-secondary">
                    {secondaryText}
                </Link>
            </div>
        </div>
    );
};

export default GuideCTA;
